import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=23c4a039&scoped=true&"
import script from "./Supplier.vue?vue&type=script&lang=js&"
export * from "./Supplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c4a039",
  null
  
)

export default component.exports